<template lang="pug">
#deals.center-panel
  route-list-selector(ref="RouteListSelector")
  md-content.content-area(md-theme="white" v-loader-overlay="progress")
    sort-table(
      v-if="Object.keys(statuses)" ref="delastable" v-bind:columns="tableColumns" v-model="deals" v-on:refresh="getDeals" 
      v-bind:per-page="count" v-bind:total="dealsAmount" link table-id="deals" default-order="desc" 
      default-sort="id" selected-field="select" select-item-field="first_freight_id"
      v-on:change-selected="changeSelected" v-on:create="addDeal"
      v-bind:noBreackColumns="['traking_number', 'id']"
      v-bind:loadOnScroll="true"
      :refreshOnCreate="true"
      :cursorPagination="true"
      :isLastPage="isLastPage"
    )
      template(slot="head" v-if="selectedFreights && selectedFreights.length")
        md-button.md-dense.md-accent(v-if="isUserAdmin" v-on:click="removeDeals") Удалить заявки
        md-button.md-dense.md-primary(v-if="!selectedCanceledFreights.length && !selectedAcceptedFreights.length" v-on:click="createRouteList") Создать маршрутный лист
        md-button.md-dense.md-default(v-if="!selectedCanceledFreights.length && !selectedAcceptedFreights.length" v-on:click="addToRouteList") Добавить к маршрутному листу

      template(slot="buttons")
        md-button.md-dense(v-on:click="addDeal") Добавить #[md-icon add]
        md-button.md-dense.md-primary(v-if="isUserAgent" v-on:click="addAgentDeal") Принять груз #[md-icon add]

      template(slot="first_freight.weight" slot-scope="scope") 
        span {{ (scope.item.first_freight && scope.item.first_freight.weight) ? scope.item.first_freight.weight : 'Не установлен'}}

      template(slot="first_freight.size" slot-scope="scope") 
        span {{ (scope.item.first_freight && scope.item.first_freight.size) ? scope.item.first_freight.size : 'Не установлен' }}

      template(slot="first_freight.seats_number" slot-scope="scope") 
        span {{ (scope.item.first_freight && scope.item.first_freight.seats_number) ? scope.item.first_freight.seats_number : 'Не установлен' }}

      template(slot="id" slot-scope="scope")
        span.no-breack-words {{ (scope.item.first_freight) ? scope.item.first_freight.traking_number : '' }}

      template(slot="route_lists" slot-scope="scope")
        .router-list-container(v-if="scope.item.route_lists && scope.item.route_lists.length")
          .router-lists(v-bind:class="{'many': (scope.item.route_lists.length > 1)}")
            .router-list-link(@click.stop.prevent="openRouteList(routeList.id)" v-for="routeList in scope.item.route_lists" v-bind:key="routeList.id") {{routeList.id}}

      template(slot="sender.name" slot-scope="scope")
        .no-break-hidden: span {{ (scope.item.sender ? scope.item.sender.name : '') }}

      template(slot="recipient.name" slot-scope="scope")
        .no-break-hidden: span {{ scope.item.recipient ? scope.item.recipient.name : '' }}

      template(slot="status" slot-scope="scope")
        //.no-break-hidden
          span(
            v-if="scope.item.status && scope.item.status.id" v-bind:style="'color: ' + scope.item.status.color"
          ) {{scope.item.status.name}}
          span(v-else) Не установлен
        ZDealStatusChanger(
          v-if="scope && scope.item && scope.item.id"
          v-model="scope.item.status_id" 
          v-bind:deal-id="scope.item.id" 
          v-bind:disabled="!!(scope.item && scope.item.route_lists && scope.item.route_lists.length > 0)"
          hide-label
        )

      template(slot="frstatus" slot-scope="scope")
        .no-break-hidden(
            v-if="scope.item.first_freight && scope.item.first_freight.currenttracking && scope.item.first_freight.currenttracking.status_id && getStatus(scope.item.first_freight.currenttracking.status_id, 0)"
            v-bind:style="'color: ' + getStatus(scope.item.first_freight.currenttracking.status_id, 2)"
        )
          span {{getStatus(scope.item.first_freight.currenttracking.status_id, 1)}}
        .no-break-hidden(v-else) 
          span(
              v-if="scope.item.first_freight && scope.item.first_freight.status && scope.item.first_freight.status.name"
              v-bind:style="'color: ' + getStatus(scope.item.first_freight.status_id, 2)"
            ) {{scope.item.first_freight.status.name}}
          span(v-else) Не установлен
            

      template(slot="created_at" slot-scope="scope") {{ ((scope.item.created_at) ? moment(scope.item.created_at).format('DD.MM.YYYY') : '') }}

      template(slot="first_freight.services" slot-scope="scope")
        span {{ HasTempReg(scope.item.first_freight) ? 'Да' : 'Нет' }}

      template(slot="from" slot-scope="scope")
        .no-break-hidden(v-if="parseInt(scope.item.delivery_method_from) === 1")
          span(v-if="scope.item.from_stock") {{scope.item.from_stock.name}}
          span(v-else-if="scope.item.from_city") {{scope.item.from_city.name}}

        .no-break-hidden(v-if="parseInt(scope.item.delivery_method_from) === 2")
          span(v-if="scope.item.from_address") {{scope.item.from_address.address}}
          span(v-else-if="scope.item.from_city") {{scope.item.from_city.name}}

      template(slot="to" slot-scope="scope")
        .no-break-hidden(v-if="parseInt(scope.item.delivery_method_to) === 1")
          span(v-if="scope.item.to_stock") {{scope.item.to_stock.name}}
          span(v-else-if="scope.item.to_city") {{scope.item.to_city.name}}

        .no-break-hidden(v-if="parseInt(scope.item.delivery_method_to) === 2")
          span(v-if="scope.item.to_address") {{scope.item.to_address.address}}
          span(v-else-if="scope.item.to_city") {{scope.item.to_city.name}}

      template(slot="closest_departure_date" slot-scope="scope") {{ ((scope.item.closest_departure_date) ? moment(scope.item.closest_departure_date).format('DD.MM.YYYY') : '') }}

      template(slot="actions" slot-scope="scope")
        span
          md-button.md-icon-button.md-dense.small(@click.stop="clone(scope.item.id)")
            i.fas.fa-clone
          md-tooltip(md-direction="top") Клонировать
        //md-button.md-icon-button.md-dense.small(v-if="isUserAdmin" @click.stop="openDeleteDialog(scope.item)"): md-icon delete

    //md-button.md-dense(v-bind:to="{ name: 'DealCreate'}") Создать заявку #[md-icon add]
    //- диалог удаления заявки
    md-dialog(v-bind:md-active.sync="deleteDialog" md-theme="white")
      md-dialog-title Удалить заявку {{ (dealToDelete && dealToDelete.first_freight && dealToDelete.first_freight.traking_number)  ? dealToDelete.first_freight.traking_number + '?' : '?' }}
      md-dialog-actions
        md-button.md-primary(@click="deleteDialog = false") Отмена
        md-button.md-primary(@click="deleteDeal(dealToDelete.id)") Удалить
</template>
<script>
import moment from "moment";
import SortTable from "@/components/SortTable";
import RouteListSelector from "@/components/RouteListSelector";
import ZDealStatusChanger from '@/components/ZDealStatusChanger';
export default {
  components: {SortTable, RouteListSelector, ZDealStatusChanger},
  data() {
    return {
      tableColumns: [
        { label: '', field: 'select', width: '30px'},
        { label: 'Треккод', field: 'id', width: '150px'},
        { label: 'Статус', field: 'status', width: '120px'},
        { label: 'кг', field: 'first_freight.weight', width: '50px'},
        { label: 'м<sup>3</sup>', field: 'first_freight.size', width: '50px'},
        { label: 'Мест', field: 'first_freight.seats_number', width: '25px'},
        { label: 'Отправитель', field: 'sender.name', width: ''},
        { label: 'Получатель', field: 'recipient.name', width: ''},
        { label: 'Отправление', field: 'from', width: ''},
        { label: 'Назначение', field: 'to', width: ''},
        { label: 'Темп. режим', field: 'first_freight.services', width: ''},
        { label: 'МЛ', field: 'route_lists', width: '70px'},
        { label: 'Статус трекинга', field: 'frstatus', width: '200px'},
        { label: 'Создана', field: 'created_at',  width: '80px'},
        { label: '', field: 'actions', width: '30px'},
      ],
      currentPage: 1,
      count: 50,
      moment: moment,
      dealToDelete: {},
      deleteDialog: false,
      status: this.$cookie.get('filterDealsByStatus') || 'all',
      noDocuments: this.$cookie.get('filterDealsByDocuments') || null,
      selectedFreights: [],
      deals: []
    }
  },
  metaInfo() {
    return {
      title: 'Заявки'
    }
  },
  created() {
      this.getDealStatuses();
      this.$nextTick(() => {
          this.getStatuses(1, 999, 'id', 'asc').finally(() => this.$store.dispatch('deals/getStatuses', { cache: true }));
          this.$store.commit('setTitle', 'Заявки');
          if (this.$refs.delastable) this.$refs.delastable.$emit('clear-selected');
      });
      this.$store.commit('setBigSizePanel');
  },
  updated: function () {},
  computed: {
    progress() {
       return this.progressObj['get-deals-list'];
    },
    progressObj() {
      return this.$store.state.progressObj;
    },
    dbDeals() {
      return this.$store.state.deals.deals
    },
    dealsAmount() {
      return this.$store.state.deals.deals_amount
    },
    totalPages() {
      return Math.ceil(this.dealsAmount / this.count)
    },
    statuses() {
        let DBStatuses = this.$store.state.stock.freight_statuses, statuses = {};
        if (DBStatuses && DBStatuses.length) DBStatuses.map(status => {statuses[status.id] = status;});
        else statuses = {};
        return statuses;
    },
    stateSelectedFreight() {
      return this.$store.state.stock.itineraryFreight;
    },
    selectedCanceledFreights() {
      if (!this.deals) return [];
      return this.deals.filter(deal => (deal.first_freight && (this.selectedFreights.indexOf(deal.first_freight.id) + 1) && deal.status && deal.status.type == 'canceled')).map(item => item.first_freight.id);
    },
    selectedAcceptedFreights() {
      if (!this.deals) return [];
      return this.deals.filter(deal => (deal.first_freight && (this.selectedFreights.indexOf(deal.first_freight.id) + 1) && deal.status && deal.status.type == 'accepted')).map(item => item.first_freight.id);
    },
    selectedConfirmedFreights() {
      if (!this.deals) return [];
      return this.deals.filter(deal => (deal.first_freight && (this.selectedFreights.indexOf(deal.first_freight.id) + 1) && deal.status && deal.status.type == 'confirmed')).map(item => item.first_freight.id);
    },
    user() {
      return this.$store.state.users.current;
    },
    isUserAgent() {
      return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('agent')+1) : false;
    },
    isUserAdmin() {
      return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('administrators')+1) : false;
    },
    cursor() {
      return this.$store.state.deals.deals_cursor;
    },
    isLastPage() {
      return this.$store.state.deals.deals_last;
    }
  },
  watch: {
    'dbDeals'(deals) {
      if (deals && deals.length) {
        deals.map(item => {
          item.selected = false;
          if (item.first_freight) item.first_freight_id = item.first_freight.id;
          item.routerLink = { name: 'DealNew', params: { id: item.id }, query: this.$route.query };
          return item;
        });
        this.deals = Object.assign([], deals);
      } else this.deals = Object.assign([], []);
      
      this.searchSelectedFreights();
    },
    '$route.name'(name) {
      this.selectedFreights = Object.assign([], this.stateSelectedFreight);
      //Нужно чтобы сбрасывались чекбоксы, когда пользователь жмёт "Отмена" на форме создания МЛ
      if (name != 'ItineraryFreights' && this.$refs.delastable) this.$refs.delastable.$emit('clear-selected');
      if (name == 'DealsNew') this.$store.commit('setTitle', 'Заявки');
    },
    'stateSelectedFreight'(value) {
      if (JSON.stringify(this.selectedFreights) != JSON.stringify(value)) {
        this.selectedFreights = Object.assign([], value);
        this.searchSelectedFreights();
        if (this.$refs.delastable) this.$refs.delastable.changeSelected(this.selectedFreights);
      }
    },
  },
  methods: {
    openRouteList(id) {
      window.open((this.$router.resolve({name: 'ItineraryFreights', params: {id:id}})).href, '_blank');
    },
    HasTempReg(freight) {
      if (!freight || !freight.services || !Array.isArray(freight.services) || !freight.services.length) return false;
      return !!freight.services.find(item => parseInt(item.id) === 22);
    },
    searchSelectedFreights() {
      this.deals.map((item, i) => {
        if (item.first_freight && item.first_freight.id && (this.selectedFreights.indexOf(parseInt(item.first_freight.id))+1)) item.selected = true;
        else item.selected = false;
        this.$set(this.deals, i, item);
      });
    },
    getStatus(id, type) {
        if (type === 1 && this.statuses[id]) return this.statuses[id]['name'];
        else if(type === 2 && this.statuses[id]) return this.statuses[id]['color'];
        else return this.statuses;
    },
    getStatuses(page, count, orderBy, orderType) {
        return this.$store.dispatch('stock/getTrackingStatuses', {
          page: page, order_by: orderBy, order_type: orderType, count: count, cache: true
        })
    },
    getDealStatuses() {
      return this.$store.dispatch('deals/getAllStatuses');
    },
    getDeals(page, count, orderBy, orderType, filter, reload) {
      if ((this.progress || this.isLastPage) && !reload) return;
      if (count) this.count = count;
      if (page)  this.currentPage = page;
      this.$store.commit('deals/setCurrentDealsPage', page);
      if (reload) this.$store.commit('showProgressBar', 'get-deals-list');
      else this.$store.commit('showProgressBar');
      
      let params = {
          cursor:     this.cursor && !reload ? this.cursor : 0,
          count:      (count)     ? count     : this.count,
          order_by:   (orderBy)   ? orderBy   : 'id',
          order_type: (orderType) ? orderType : 'desc',
          //filter:     (filter)    ? filter    : this.getFilter(),
          //data:       (symbol)    ? symbol    : '=',
          filter: this.getFilter(),
          year:  this.$cookie.get('filterDealsByYear') || this.moment().format('Y'),
          number: this.getFilterByNumber(),
          data:   '=',
          custom_filter: (this.$route.query && this.$route.query.custom_filter) ? JSON.parse(this.$route.query.custom_filter) : null,
          concat: !reload
      };

      return this.$store.dispatch('deals/getDeals', params).finally(() => {
        this.$store.commit('hideProgressBar', 'get-deals-list');
        this.$store.commit('hideProgressBar');
      });
    },
    getFilterByNumber() {
        const search = this.$route.query.search;
        if (
          `${search}`.indexOf('-') + 1 &&
          `${search}`.replace(/[^0-9]/g, '').length > 1 &&
          `${search}`.split('-').at(0)
        ) return `${search}`.split('-').at(0)

        if (parseInt(search) > 0) return parseInt(search)

        return null
    },
    getFilter() {
        let filter = {model: [], relation: [], condition: 'and'};
        if (this.$route.query.responsible_id) {
            filter.model = [
                ['responsible_id',    '=', this.$route.query.responsible_id], 'or',
                ['forwarder_from_id', '=', this.$route.query.responsible_id], 'or',
                ['forwarder_to_id',   '=', this.$route.query.responsible_id]
            ];
        } else if (this.$route.query.customer_id) {
            filter.model = [
                ['applicant_id', '=', this.$route.query.customer_id], 'or',
                ['sender_id',    '=', this.$route.query.customer_id], 'or',
                ['recipient_id', '=', this.$route.query.customer_id], 'or',
                ['payer_id',     '=', this.$route.query.customer_id]
            ];
        } else if (this.$route.query.address_id) {
            /*
            filter.model = [
                ['from_address_id', '=', this.$route.query.address_id], 'or',
                ['to_address_id',   '=', this.$route.query.address_id]
            ];
            filter.condition = 'or';
            */
            filter.relation = [
                ['fromAddress', 'address', '%', this.$route.query.search_string], 'or',
                ['toAddress',   'address', '%', this.$route.query.search_string]
            ];
        }

        let statusId = this.$cookie.get('filterDealsByStatus');
        if (statusId && statusId != 'all') {
            if (filter.relation.length) {
                filter.relation.push('and');
                filter.relation.push(['firstFreight','status_id','=', statusId]);
            } else filter.relation = [['firstFreight','status_id','=', statusId]];
        }

        let dealStatusId = this.$cookie.get('filterDealsByDealStatus');
        if (dealStatusId && dealStatusId != 'all') {
            if (filter.model.length) {
                filter.model.push('and');
                filter.model.push(['status_id','=', dealStatusId]);
            } else filter.model = [['status_id','=', dealStatusId]];
        }

        return filter;
    },
    changePage(page) {
      this.currentPage = page
    },
    //удаление заявки
    deleteDeal(id) {
      this.$store.commit('showProgressBar');
      this.$store.dispatch('deals/deleteDeal', { deal_id: id }).then(() => {
        //this.$root.$emit('reload-table', 'deals');
        this.$store.commit('hideProgressBar');
        this.$store.commit('showSnackbar', ['Заявка успешно удалена, обновление списка заявок...', 6000, 'success']);
      });
      this.deleteDialog = false;
      //this.$router.push({ name: 'Deals' });
    },
    //открытие диалога удаления заявки
    openDeleteDialog(deal) {
      this.dealToDelete = Object.assign({}, deal);
      this.deleteDialog = true;
    },
    changeSelected(val) {
      this.selectedFreights = Object.assign([], val);
      if (this.$route.name === 'ItineraryFreights' && this.$route.params && (!this.$route.params.id || this.$route.params.id == 'new')) this.createRouteList();
    },
    createRouteList() {
      this.$store.commit('stock/changeItineraryFreight', this.selectedFreights);
      this.searchSelectedFreights();
      if (this.selectedFreights.length) this.$router.push({name: 'ItineraryFreights', query: this.$route.query, params: {id: 'new'}});
    },
    addToRouteList() {
      if (!this.selectedFreights.length || !this.$refs.RouteListSelector) return;

      this.$refs.RouteListSelector.$emit('select', this.selectedFreights, (routeListId) => {
        if (routeListId && this.selectedFreights && this.selectedFreights.length) {
          this.$store.commit('showSnackbar', ['Идёт добавление грузов, пожалуйста подождите...', 5000]);
          this.$store.dispatch('deals/addFreightsToRouteList', {id: routeListId, freights: this.selectedFreights}).then(r => {
            if (r) this.$store.commit('showSnackbar', ['Грузы успешно добавленны', 3000]);
          });
        }

      });
    },
    removeDeals() {
      if (!this.dbDeals || !this.dbDeals.length || !this.selectedFreights || !this.selectedFreights.length) return;
      let dealsToRemove = [];
      this.dbDeals.map(deal => {
        if ((this.selectedFreights.indexOf(deal.first_freight_id)+1)) dealsToRemove.push(deal.id);
      });
      
      if (!dealsToRemove.length) return;
      this.$store.commit('showProgressBar');
      this.$store.dispatch('deals/deleteDeals', { ids: dealsToRemove }).then(() => {
        //this.$root.$emit('reload-table', 'deals');
        this.$store.commit('hideProgressBar');
        this.$store.commit('showSnackbar', ['Заявки успешно удалены, обновление списка заявок...', 6000, 'success']);
        if (this.$refs.delastable) this.$refs.delastable.$emit('clear-selected');
        //this.$router.push({ name: 'Deals' });
      });
    },
    addDeal() {
      this.$router.push({name: 'DealNew', params: {id: 'new'}});
    },
    addAgentDeal() {
      this.$router.push({name: 'DealNew', params: {id: 'new'}, query: {agent: true}});
    },
    clone(id) {
      let query = this.$route.query;
      if (query) query.clone_id = id;
      else query = {clone_id: id};

      this.$router.push({ name: 'DealNew', params: { id: 'new' }, query: query});
    },
    HasTempReg(freight) {
      if (!freight || !freight.services || !Array.isArray(freight.services) || !freight.services.length) return false;
      return !!freight.services.find(item => parseInt(item.id) === 22);
    }
  }
}
</script>

<style src="./Deals.sass" lang="sass"></style>



// WEBPACK FOOTER //
// Deals.vue?2b0e0cd8